import React, { useEffect, useState } from 'react';
import { getCachedMediaUrl } from '../../../../../../lib/utils/utils';
import { useSelector } from 'react-redux';

function ProductCard({ product }) {
    const [nameSize, setNameSize] = useState(0);
    const [nameLineHeight, setNameLineHeight] = useState(0);

    const [descSize, setDescSize] = useState(0);
    const [descLineHeight, setDescLineHeight] = useState(0);

    const [priceSize, setPriceSize] = useState(0);
    const [priceLineHeight, setPriceLineHeight] = useState(0);

    const [padding, setPadding] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    useEffect(() => {
        setNameSize((zoomSize/100)*8);
        setNameLineHeight((zoomSize/100)*14);

        setDescSize((zoomSize/100)*6.46);
        setDescLineHeight((zoomSize/100)*13);

        setPriceSize((zoomSize/100)*10.76);
        setPriceLineHeight((zoomSize/100)*17.22);
        setPadding((zoomSize/100)*8.61);
    }, [zoomSize]);

    return (
        <div className="flex flex-col rounded-lg overflow-hidden bg-[#F3F3F3]">
            <div className="w-full aspect-square rounded-lg overflow-hidden">
                <img className='size-full object-cover' src={product?.productImgUrls[0]} alt={product.productName} />
            </div>

            <div style={{ paddingTop: `${padding}px`, paddingBottom: `${padding*2}px`, paddingLeft: `${padding}px`,paddingRight: `${padding}px` }} className="flex flex-col">
                <div className='flex items-center gap-1'>
                    <p style={{ fontSize: `${priceSize}px`, lineHeight: `${priceLineHeight}px` }} className='font-semibold text-[#000000]'>₹{product.productSellingPrice}</p>

                    {
                        product.productMRP > product.productSellingPrice && 
                        <>
                            <p style={{ fontSize: `${nameSize}px`, lineHeight: `${nameLineHeight}px` }} className='font-semibold text-[#666666] line-through'>₹{product.productMRP}</p>

                            <p style={{ fontSize: `${descSize}px`, lineHeight: `${descLineHeight}px` }} className='font-medium text-primaryColor'>{Math.round(((product.productMRP - product?.productSellingPrice) / product.productMRP) * 100).toFixed(0)}% off</p>
                        </>
                    }
                </div>

                <p style={{ fontSize: `${nameSize}px`, lineHeight: `${nameLineHeight}px` }} className='font-semibold text-[#000000] line-clamp-1'>{product.productName}</p>

                <p style={{ fontSize: `${descSize}px`, lineHeight: `${descLineHeight}px` }} className='line-clamp-1 font-medium text-[#666666]'>{product.productDesc}</p>
            </div>
        </div>
    )
}

export default ProductCard;
